import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.746 8.33c0-.21-.085-.402-.255-.56L9.87 2.25C9.683 2.067 9.505 2 9.302 2c-.416 0-.738.3-.738.718 0 .2.068.393.203.526l1.9 1.904 3.366 3.023.17-.418-2.73-.167H.745c-.44 0-.746.309-.746.743s.305.743.746.743h10.726l2.73-.167-.17-.409-3.365 3.015-1.9 1.903c-.135.126-.203.326-.203.526 0 .418.322.718.738.718a.78.78 0 0 0 .55-.233l5.64-5.536a.75.75 0 0 0 .254-.56"
    }, null, -1)
  ])))
}
export default { render: render }